import { CircularProgress } from '@material-ui/core'
import React from 'react'

export const Loading = ({style, loaderSize}) => {
    return ( <div style={{ width: "100%", height: "80vh", display: "flex", justifyContent: "center", alignItems: "center",...style }}>
           {loaderSize ? <CircularProgress style={{color:"rgb(20, 155, 227)"}} size={loaderSize} /> : <CircularProgress style={{color:"rgb(20, 155, 227)"}} /> }
        </div>
    )
}
